import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const ErrorCard = ({
  errorMessage,
  title,
}: { errorMessage: string; title: string }) => {
  return (
    <Card className="w-[350px]" style={{ overflow: "visible" }}>
      <CardHeader style={{ overflow: "visible" }}>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>{errorMessage}</CardContent>
    </Card>
  );
};
